module.exports = __webpack_public_path__ + "static/media/savereurope-logo.bbd81bdc.svg";